import {ViewSimpleSelect} from "../view/view-simple-select";

export class GeoreferencerSimpleSelect extends ViewSimpleSelect {

}
